import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const DropDownInput = ({
  label,
  id,
  value,
  onChange,
  options = [], // Options for the dropdown
  placeholder = "",
  className = "",
  labelClassName = "",
  disabled = false, // Disabled prop
  error = "",
}) => {
  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <label
          htmlFor={id}
          className={`text-body1 font-ptsans text-secondary/90  font-medium pl-2 block${labelClassName}`}
        >
          {label}
        </label>
      )}
      <Select
        disabled={disabled}
        value={value}
        onValueChange={onChange}
        className={className}
      >
        <SelectTrigger
          className={`${disabled ? "cursor-not-allowed !bg-background_2" : ""}`}
        >
          <SelectValue
            placeholder={placeholder}
            className="[data-placeholder]:text-primary/60"
          />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && (
        <span className="text-caption text-red-500 font-ptsans pl-2">
          {error}
        </span>
      )}
    </div>
  );
};

export default DropDownInput;
